import React from "react";
import PropTypes from "prop-types";

const FaceShape = (props) => {
  const { color } = props;
  return (
    <svg
      data-testid="faceShape-svg"
      className="face-shape"
      fill={color}
      viewBox="0 0 70 106"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <path d="M55.2898135,5.29988972 C49.485163,1.72327001 43.0819522,0.111628559 36.2637606,0.00524382983 C34.0133353,-0.0296364093 31.7494217,0.113023769 29.5070542,0.328060443 C25.7223036,0.691686935 22.1104471,1.71821237 18.6742874,3.31415771 C16.3611507,4.38881788 14.1858738,5.68270035 12.1186776,7.15080961 C9.60006499,8.93824746 7.46122372,11.0784989 5.72562673,13.600689 C3.30983968,17.1126059 1.86467666,21.003671 1.04627646,25.115528 C0.647061125,27.1211417 0.38535524,29.1590197 0.1861855,31.193584 C0.0264292976,32.8266768 -0.0354061625,34.4796513 0.0197727891,36.1184994 C0.107008084,38.7097523 0.301973713,41.2989125 0.501143453,43.8849334 C0.656170031,45.8963024 0.889848512,47.902265 1.08428863,49.9106691 C1.24527103,51.5753285 1.40590309,53.2389415 1.5558497,54.9046473 C1.70124186,56.5122776 1.83367134,58.1214774 1.96907874,59.7299796 C2.13373974,61.6830986 2.27597881,63.6383104 2.46341208,65.5898598 C2.64786743,67.5115866 2.82041113,69.4371502 3.09910863,71.3477153 C3.53668648,74.3510782 4.34054746,77.2804951 5.19082883,80.1954367 C6.23712685,83.7847877 7.50186346,87.2897285 9.41841238,90.5451013 C11.1427984,93.4755645 13.23592,96.1137314 15.9297038,98.2686326 C20.5041265,101.926174 25.8309098,103.652223 31.6851338,103.967366 C32.9290251,104.034336 34.1806238,103.977481 35.4281936,103.977481 C37.8940797,104.007478 40.359265,104.022128 42.8037802,103.623447 C45.2873585,103.218487 47.6428867,102.483735 49.8362062,101.254904 C62.3204878,94.2589747 66.22961,79.6947309 67.6229223,66.4630866 C67.8068521,64.7150634 67.9112542,62.9590178 68.0582229,61.2066345 C68.2766615,58.6213112 68.4928228,56.0358135 68.7245744,53.4518854 C68.9116574,51.3557574 69.1378035,49.2629431 69.3159527,47.1659431 C69.5471787,44.4376108 69.8179935,41.7096273 69.9449927,38.9758886 C70.1142082,35.3391004 69.8933172,31.7139972 69.2781157,28.1150541 C68.3975297,22.9623708 66.6698154,18.1171568 63.7745845,13.6913776 C61.561821,10.3090409 58.7876335,7.4553141 55.2898135,5.29988972 Z" />
      </g>
    </svg>
  );
};

FaceShape.propTypes = {
  color: PropTypes.string,
};

FaceShape.defaultProps = {
  color: "#FFFFFF",
};

export default FaceShape;
